;(function() {
/* @ngInject */
function ModalExecutionType($uibModal, $rootScope) {
  let executionType;
  let executionTypeOther;
  let executionTypeActual;

  return function init(executionType_, executionTypeOther_, executionTypeActual_) {
    executionType = executionType_;
    executionTypeOther = executionTypeOther_;
    executionTypeActual = executionTypeActual_;

    return { add };
  };

  function open(options = {}) {
    return $uibModal.open(angular.extend({
      templateUrl: "/app/shared/modal-execution-type/modal-execution-type.html",
      controller: "ModalExecutionTypeController",
      controllerAs: "vm",
      bindToController: true,
      size: "md",
      backdrop: "static",
      resolve: {
        executionType: () => executionType,
        executionTypeOther: () => executionTypeOther,
        executionTypeActual: () => executionTypeActual
      }
    }, options));
  }

  function add(scope = {}) {
    return open({ scope: angular.extend($rootScope.$new(true), scope) })
  }
}

/* @ngInject */
function ModalExecutionTypeController($uibModalInstance, $scope, executionType, executionTypeOther, executionTypeActual) {
  let vm = this;

  vm.executionType = executionType;
  vm.executionTypeOther = executionTypeOther;
  vm.executionTypeActual = executionTypeActual;

  vm.executionTypes = ["onTheirOwn", "together", "actual", "other"];

  if(vm.executionTypeActual === "") {
    vm.executionTypes = vm.executionTypes.filter(e => {
      return e !== "actual";
    });
  }

  if(!vm.executionType)
    vm.executionType = vm.executionTypes[0];

  vm.close = () => $uibModalInstance.dismiss("cancel");

  vm.submit = () => {
    if($scope.executionType.$invalid) {
      vm.requiredMessage = true;
      vm.submitted=true;
    } else $uibModalInstance.close({executionType: vm.executionType, executionTypeOther: vm.executionTypeOther});
  }

}

angular.module("firmaren")
  .factory("ModalExecutionType", ModalExecutionType)
  .controller("ModalExecutionTypeController", ModalExecutionTypeController);
}());
